import React, { useEffect } from 'react';
import { connect, useSelector, useDispatch } from "react-redux";
import Dots from "react-activity/lib/Dots";
import 'react-activity/lib/Dots/Dots.css';
import Home from "./pages/Home";


import { View } from "react-native-web";
import Login from "./pages/Login";
import { AuthContext } from "../shared/core/context";
import { validatePatientTokenFromApi } from "../shared/actions/TokenValidActions";
import getUserId from "../shared/core/GetToken";
import { Modal, Button, Space } from 'antd';
import Appointments from "./pages/Appointments";
import Diagnosis from "./pages/Diagnosis";
import Med from "./pages/Med";
import PatientResults from "./pages/PatientResults";
import AllergiesHome from "./pages/AllergiesHome";
import ImmuneHome from "./pages/ImmuneHome";
import TimelineHome from './pages/TimelineHome';
import RemidersHome from './pages/RemidersHome';
import ResourcesHome from './pages/ResourcesHome';
import ForgetPassword from "./pages/ForgetPassword";
import LettersDocs from "./pages/LettersDocs";
import Vitals from "./pages/Vitals";
import ResetPassword from './pages/ResetPassword';
import Messaing from "./pages/Messaing";
import MessagesHome from "./pages/MessagesHome";
import UserProfile from "./pages/UserProfile";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import OuterHtml from './components/OutterHtml';
import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import ProfileScreen from './pages/ProfileScreen';
import Accounts from './pages/Accounts';
import RepeatedMedcation from './pages/RepeatedMedcation';
import ReadMessage from './pages/ReadMessage';
const Route = require("react-router-dom").Route;
const Switch = require("react-router-dom").Switch;
const Router = require("react-router-dom").BrowserRouter;

const Redirect = require("react-router-dom").Redirect;
const useHistory = require("react-router-dom").useHistory;
const loadjs = require('loadjs');
//function Main() {
const Main = props => {
    useGoogleAnalytics();
    const [userToken, setUserToken] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const { TokenValidator, isChecking, showModal } = props.TokenValidator;
    const linkHistory = useHistory();

    // React.useEffect(() => {
    //     loadjs(['http://indici-pre-production.web.app/assets/js/template.js', 'http://indici-pre-production.web.app/assets/js/dashboard.js'], 'foobar');
    //     loadjs.ready('foobar', function () {

    //     });
    // }, [])

    React.useEffect(() => {

        getUserId().then((data) => {
            if (data != 'none') {
                props.validateToken(linkHistory);
            }
        })
    }, []);
    React.useEffect(() => {

        if (!TokenValidator) {
            //alert('hello')
            // if (showModal) {
            //     Modal.warning({
            //         title: 'This is a warning message',
            //         content: 'some messages...some messages...',
            //     });
            // }

            authContext.signOut()
            console.log("useLogout")
        } else {
            console.log("useLogin" + TokenValidator)
        }
    }, [TokenValidator]);
    //context api
    const authContext = React.useMemo(() => {
        return {
            signIn: () => {
                setUserToken(true);
            },
            signOut: () => {
                setUserToken(false);
                // location.reload();
            },
        }
    })


    const warning = () => {
        Modal.warning({
            title: 'This is a warning message',
            content: 'some messages...some messages...',
        });
    }
    return (

        <AuthContext.Provider value={authContext}>
            {/* <Switch>
                <Route exact path="/" component={Login} />
            </Switch> */}


            {
                isChecking &&
                <View style={{
                    opacity: 1,
                    position: 'relative',
                    backgroundColor: '#fff',
                    flex: 1,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Dots />
                </View>

            }
            {
                !isChecking &&
                <Switch>



                    <PublicRoute exact path="/login" component={Login} authed={TokenValidator} />
                    <PublicRoute exact path="/forgetPassword" component={ForgetPassword} authed={TokenValidator} />
                    <PublicRoute exact path="/resetpassword" component={ResetPassword} authed={TokenValidator} />

                    <PrivateRoute exact path="/preview" component={OuterHtml} authed={TokenValidator} />



                    <PrivateRoute exact path="/" component={Home} authed={TokenValidator} />
                    <PrivateRoute exact path="/appointments" component={Appointments} authed={TokenValidator} />
                    <PrivateRoute exact path="/diagnosis" component={Diagnosis} authed={TokenValidator} />


                    <PrivateRoute exact path="/medications" component={Med} authed={TokenValidator} />
                    <PrivateRoute exact path="/reports" component={PatientResults} authed={TokenValidator} />
                    <PrivateRoute exact path="/allergies" component={AllergiesHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/immunisation" component={ImmuneHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/timeline" component={TimelineHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/reminders" component={RemidersHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/resources" component={ResourcesHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/letters" component={LettersDocs} authed={TokenValidator} />
                    <PrivateRoute exact path="/vitals" component={Vitals} authed={TokenValidator} />
                    <PrivateRoute exact path="/emails" component={MessagesHome} authed={TokenValidator} />
                    <PrivateRoute exact path="/profile" component={ProfileScreen} authed={TokenValidator} />
                    <PrivateRoute exact path="/profile-old" component={UserProfile} authed={TokenValidator} />
                    <PrivateRoute exact path="/accounts" component={Accounts} authed={TokenValidator} />
                    <PrivateRoute exact path="/medication" component={RepeatedMedcation} authed={TokenValidator} />
                    {/* <PrivateRoute exact path="/inbox" component={MessagesHome} authed={TokenValidator} /> */}

                    <PrivateRoute exact path="/read" component={ReadMessage} authed={TokenValidator} />


                    {/* <PrivateRoute exact path="/" component={Home} />
                        <PrivateRoute exact path="/appointments" component={Appointments} /> */}
                    {/* <PrivateRoute exact path="/diagnosis" component={Diagnosis} />
                        */}

                </Switch>



            }

            {/* {
                isChecking &&
                <View style={{
                    opacity: 1,
                    position: 'relative',
                    backgroundColor: '#fff',
                    flex: 1,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Dots />
                </View>

            }
            {
                !isChecking && userToken != null || TokenValidator ? (
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/appointments" component={Appointments} />
                        <Route exact path="/diagnosis" component={Diagnosis} />
                        <Route exact path="/medications" component={Med} />
                        <Route exact path="/reports" component={PatientResults} />
                        <Route exact path="/allergies" component={AllergiesHome} />
                        <Route exact path="/immunisation" component={ImmuneHome} />
                        <Route exact path="/timeline" component={TimelineHome} />
                        <Route exact path="/reminders" component={RemidersHome} />
                        <Route exact path="/resources" component={ResourcesHome} />
                        <Route exact path="/letters" component={LettersDocs} />
                        <Route exact path="/vitals" component={Vitals} />
                        <Route exact path="/emails" component={Messaing} />
                        <Route exact path="/profile" component={UserProfile} />

                    </Switch>
                ) : (
                        <Switch>
                            <Route exact path="/" component={Login} />
                            <Route exact path="/forgetPassword" component={ForgetPassword} />
                            <Route exact path="/resetpassword" component={ResetPassword} />
                        </Switch>
                    )
            } */}

            {/* <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/appointments" component={Appointments} />
            </Switch> */}
        </AuthContext.Provider >
    );
}




function mapStateToProps(state) {
    return {
        TokenValidator: state.TokenValidator,

    }
}
function mapDispatchToProps(disptach) {
    return {
        validateToken: (history) => disptach(validatePatientTokenFromApi(history)),

    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Main)
